<h1>{{title}}</h1>
<div class='palette' *ngFor='let group of palette'>
  <ng-container *ngFor='let color of group'>
    <div class="container">
      <div [class]='"swatch backgroundColor--" + color[0]' ></div>
      <span [class]='"swatch color--" + color[0]'>{{color[1]}}</span>
    </div>
  </ng-container>
</div>